import { render, staticRenderFns } from "./answer.vue?vue&type=template&id=07ed4b14&scoped=true&"
import script from "./answer.vue?vue&type=script&lang=ts&"
export * from "./answer.vue?vue&type=script&lang=ts&"
import style0 from "./answer.vue?vue&type=style&index=0&id=07ed4b14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ed4b14",
  null
  
)

export default component.exports